// DOSYA YOLU: src/components/TestPage.js

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { db, auth } from "../firebase";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { saveTestResult } from "../services/firestoreResultService"; 

import {
  calculateDisc,
  calculateOcean,
  calculateRiasec,
} from "../services/calculateScores";

export default function TestPage() {
  const { testKey } = useParams(); // disc, ocean, riasec
  const navigate = useNavigate();
  const user = auth.currentUser; 

  const [testInfo, setTestInfo] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [index, setIndex] = useState(0); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // --- 1) FIRESTORE'DAN VERİ ÇEKME ---
  useEffect(() => {
    if (!user) {
        navigate("/login");
        return;
    }

    async function loadData() {
      try {
        const infoRef = doc(db, "tests", testKey);
        const infoSnap = await getDoc(infoRef);

        if (!infoSnap.exists()) {
            throw new Error(`Test içeriği bulunamadı: ${testKey}`);
        }
        setTestInfo(infoSnap.data());

        const qCol = collection(db, "tests", testKey, "questions");
        const qSnap = await getDocs(qCol);
        
        // Soruları id veya order'a göre sırala
        const loadedQuestions = qSnap.docs
            .map((d) => ({ id: d.id, ...d.data() }))
            .sort((a, b) => (a.order || 0) - (b.order || 0));
            
        setQuestions(loadedQuestions);
        
        const answersRef = doc(db, "users", user.uid, "answers", testKey);
        const answersSnap = await getDoc(answersRef);
        if (answersSnap.exists()) {
             const existingAnswers = answersSnap.data().answers || {};
             setAnswers(existingAnswers);
             
             // İlk cevaplanmamış soruyu bul
             const firstUnansweredIndex = loadedQuestions.findIndex(q => !existingAnswers.hasOwnProperty(q.id));
             
             if (answersSnap.data().isCompleted) {
                 navigate(`/results/${testKey}`);
             } else if (firstUnansweredIndex !== -1) {
                 setIndex(firstUnansweredIndex);
             }
        }

      } catch (err) {
        console.error("Test yükleme hatası:", err);
        setError("Veri yüklenirken hata oluştu.");
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [testKey, navigate, user]);
  
  const currentQuestion = questions[index];
  const isAnswered = currentQuestion && answers.hasOwnProperty(currentQuestion.id);

  // --- 2) Cevap Seçimi ---
  const handleSelect = (questionId, value) => {
    setAnswers((p) => ({ ...p, [questionId]: value }));
  };

  // --- 3) İlerle/Bitir ---
  const nextQuestion = async () => {
    if (!isAnswered) {
        setError("Lütfen bir seçim yapın.");
        return;
    }
    setError(null);
    
    if (index < questions.length - 1) {
      setIndex((i) => i + 1);
      return;
    }

    // SON SORU -> HESAPLA VE KAYDET
    setLoading(true);
    let scores = {};

    if (testKey === "disc") scores = calculateDisc(questions, answers);
    else if (testKey === "ocean") scores = calculateOcean(questions, answers);
    else if (testKey === "riasec") scores = calculateRiasec(questions, answers);

    if (user) {
        try {
            await saveTestResult(user.uid, testKey, {
                answers,
                scores,
                isCompleted: true,
            });
            
        } catch (saveError) {
            console.error("Sonuç kaydetme hatası:", saveError);
            setError("Sonuçlar kaydedilirken bir hata oluştu.");
            setLoading(false);
            return; 
        }
    }
    
    navigate(`/results/${testKey}`);
  };

  if (loading) return <div style={{padding:"20px", textAlign:"center"}}>Veriler yükleniyor...</div>;
  if (!testInfo || questions.length === 0) return <div style={{padding:"20px", color:"red"}}>Test içeriği bulunamadı.</div>;


  return (
    <div className="test-page" style={{ maxWidth: "800px", margin: "0 auto", padding: "20px" }}>
      <h1>{testInfo.title}</h1>
      <p>{testInfo.description}</p>
        
      {error && <div className="error-message" style={{color: "red", fontWeight: "bold"}}>{error}</div>}
        
      {currentQuestion && (
        <div className="question-block" style={{ marginTop: "30px", padding: "20px", border: "1px solid #ddd", borderRadius: "10px" }}>
          <h3>Soru {index + 1} / {questions.length}</h3>
          <p style={{ fontSize: "1.2rem", marginBottom: "20px" }}>{currentQuestion.text}</p>

          {/* CEVAP SEÇENEKLERİ */}
          {(testKey === "ocean" || testKey === "riasec") ? (
                // --- DÜZELTİLEN KISIM BAŞLANGIÇ ---
                // OCEAN ve RIASEC için veritabanından options beklemiyoruz,
                // Elle 1'den 5'e kadar buton oluşturuyoruz.
                <div className="likert-options-container" style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
                    {[1, 2, 3, 4, 5].map((score) => {
                        const isSelected = answers[currentQuestion.id] === score;
                        return (
                            <button
                                key={score}
                                onClick={() => handleSelect(currentQuestion.id, score)}
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    border: "2px solid #007bff",
                                    backgroundColor: isSelected ? "#007bff" : "white",
                                    color: isSelected ? "white" : "#007bff",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                }}
                            >
                                {score}
                            </button>
                        );
                    })}
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", marginTop: "10px", color: "#666", fontSize: "0.9rem" }}>
                        <span>(Hiç Katılmıyorum)</span>
                        <span>(Tamamen Katılıyorum)</span>
                    </div>
                </div>
                // --- DÜZELTİLEN KISIM BİTİŞ ---
            ) : (
                // DISC Tipi (A, B, C, D)
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {currentQuestion.options && currentQuestion.options.map((opt, i) => {
                        const optionValue = (currentQuestion.keyMap) 
                            ? currentQuestion.keyMap[i] 
                            : (testKey === "disc" ? ["D","I","S","C"][i] : i + 1);

                        const isSelected = answers[currentQuestion.id] === optionValue;
                        
                        return (
                            <button
                                key={i}
                                onClick={() => handleSelect(currentQuestion.id, optionValue)}
                                className={`option disc-option ${isSelected ? 'selected' : ''}`}
                                style={{
                                    padding: "15px",
                                    textAlign: "left",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: isSelected ? "#e6f7ff" : "white",
                                    borderColor: isSelected ? "#1890ff" : "#ccc",
                                    cursor: "pointer"
                                }}
                            >
                                <strong>{optionValue})</strong> {opt}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
      )}

      {/* Navigasyon Butonları */}
      <div className="navigation-buttons" style={{ marginTop: "30px", display: "flex", justifyContent: "space-between" }}>
          <button 
              onClick={() => setIndex(i => i - 1)} 
              disabled={index === 0}
              style={{ padding: "10px 20px", cursor: index === 0 ? "not-allowed" : "pointer", opacity: index === 0 ? 0.5 : 1 }}
          >
              Geri
          </button>

        <button 
            onClick={nextQuestion} 
            disabled={loading || !isAnswered}
            style={{ 
                padding: "10px 30px", 
                backgroundColor: isAnswered ? "#28a745" : "#ccc", 
                color: "white", 
                border: "none", 
                borderRadius: "5px",
                cursor: isAnswered ? "pointer" : "not-allowed"
            }}
        >
            {loading ? "İşleniyor..." : (index < questions.length - 1 ? "İleri" : "Bitir ve Sonuçları Git")}
        </button>
      </div>
    </div>
  );
}